import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { Print } from "./Print"
import { OfferPrint } from "./OfferPrint"
import { useSaleOrderModel } from "../saleOrderModel";

export default () => {
    const { offerPrint, salePrint } = useSaleOrderModel()
    return (
        <>
            <PageHeader />
            <DataBox />
            <Print />
            {offerPrint && <OfferPrint />}
        </>
    )
}